import { oidcCookie } from './auth-provider-config';

export const getOidcCookieFromCookies = () => {
    const sessionStorageToken = sessionStorage.getItem(oidcCookie);
    return sessionStorageToken ? JSON.parse(sessionStorageToken) : undefined;
};

export const getAccessTokenFromCookie = () => {
    const cookie = getOidcCookieFromCookies();
    return cookie['access_token'];
};

export const getIdTokenFromCookie = (): string | undefined => {
    const cookie = getOidcCookieFromCookies();
    return cookie?.['id_token'];
};
